/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function FindExternalUserByNameOrEmailOrCommandName(params) {
  const response = await $.soap({
    body: {
      FindExternalUserByNameOrEmailOrCommandName: {
        $xmlns: 'http://dla.mil/ems/bpm/user',
        FirstName: params.firstName,
        LastName: params.lastName,
        Email: params.email,
        CommandName: params.commandName
      }
    },
    blueprintArrays: ['FindExternalUserByNameOrEmailOrCommandNameResponse.ExternalUsers.row'],
    blueprint: {
      totalCount: '$..TotalCount',
      users: [
        'FindExternalUserByNameOrEmailOrCommandNameResponse.ExternalUsers.row',
        {
          id: '$.ID',
          otdsUserId: '$.OTDSUserID',
          firstName: '$.FirstName',
          lastName: '$.LastName',
          email: '$.Email',
          telephone: '$.Telephone'
        }
      ]
    }
  });

  cleanUpResponse(response);
  if (!response.totalCount) {
    response.totalCount = 0;
  }
  return response;
}
